import { get, post, put, del } from "../request";
import { Axios } from "@/utils/axios";

/**
 * 教师理论题库管理
 * /trainAdmin/questionInfoTeacher
 *
 * 请求体为「试题基本信息」，选项字段为 qaList；
 * 页面表单仍使用 list，在此做兼容转换。
 */
const THEORY = "/trainAdmin/questionInfoTeacher";

function toTeacherPayload(data = {}) {
  const payload = { ...data };
  if (payload.list != null && payload.qaList == null) {
    payload.qaList = payload.list;
  }
  if (Array.isArray(payload.questionAnswer)) {
    payload.questionAnswer = payload.questionAnswer.join(",");
  }
  return payload;
}

function normalizeDetailRes(res) {
  if (res && res.data) {
    const d = res.data;
    if ((!d.list || !d.list.length) && Array.isArray(d.qaList)) {
      d.list = d.qaList;
    }
  }
  return res;
}

/** 分页查询理论试题列表 */
export function getQuestionBankTable(params) {
  return get(`${THEORY}/list`, params);
}

/** 删除理论试题 */
export function removeQuestion(id) {
  return del(`${THEORY}/${id}`);
}

/** 查询理论试题详情 */
export function getQuestionBankDetail(id) {
  return get(`${THEORY}/${id}`).then(normalizeDetailRes);
}

/** 新增理论试题 POST /questionInfoTeacher */
export function addQuestion(params) {
  return post(THEORY, toTeacherPayload(params));
}

/** 修改理论试题 PUT /questionInfoTeacher */
export function editQuestion(params) {
  return put(THEORY, toTeacherPayload(params));
}

/**
 * 导入理论试题
 * 教师端文档暂无导入接口，仍走 enterAdmin/import
 */
export function questionUpload(data) {
  return Axios.post("/trainAdmin/enterAdmin/import", data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" }
  });
}



// WEBPACK FOOTER //
// ./src/api/questionBank/theory.js